import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  academyTopicSelector,
  HybridChip,
  isHybridContest,
  setAcademyTopicSelected,
} from 'features/classCreation';
import CheckboxInput from 'components/CheckboxInput';

function ClassTitle({ cls }) {
  const dispatch = useDispatch();
  const isSelected = useSelector((state) =>
    Boolean(academyTopicSelector(state, cls.academy_topic.id)?.selected)
  );
  const isHybrid = isHybridContest(cls.academy_topic.lessons);

  const handleChange = useCallback(
    (event) => {
      dispatch(
        setAcademyTopicSelected({
          academyTopicId: cls.academy_topic.id,
          selected: event.target.checked,
        })
      );
    },
    [cls.academy_topic.id, dispatch]
  );

  return (
    <CheckboxInput
      checked={isSelected}
      className="full-width"
      onChange={handleChange}
    >
      {cls.academy_topic.title}
      {isHybrid && <HybridChip className="m-l-xxs" />}
    </CheckboxInput>
  );
}

export default ClassTitle;
